import styled from 'styled-components'
import {
  background,
  border,
  color,
  flexbox,
  grid,
  layout,
  position,
  space,
  typography
} from 'styled-system'

export const StyledFooter = styled.footer`
  ${background}
  ${position}
  ${flexbox}
  ${grid}
  ${space}
  ${color}
  ${layout}
  ${typography}
  ${border}
`

export const StyledImg = styled.img`
  ${position}
  ${space}
  ${layout}
`